import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Flex } from '$components/layouts';
import { IWebRef } from '$models';
import { WebRef } from './web-ref';
import { WebRefType } from '$constants';
import { mq } from '$lib/helpers';
import { useTranslation } from '$hooks';
import { Text } from '$components/elements/text';

type ProductWebRefProps = {
    webRefs?: IWebRef[];
    productTitle?: string;
    columnView?: boolean;
};

export const ProductWebRef: FC<ProductWebRefProps> = ({
    webRefs,
    productTitle,
    columnView,
}: ProductWebRefProps): JSX.Element => {
    const { translate } = useTranslation();
    const webRefOrder: WebRefType[] = [
        WebRefType.youtube,
        WebRefType.VideoSample,
        WebRefType.vimeo,
        WebRefType.ReadSample,
        WebRefType.SoundSample,
        WebRefType.Unknown,
    ];

    const sortedWebRefs = webRefs?.sort((a, b) => {
        return webRefOrder.indexOf(a.type as WebRefType) - webRefOrder.indexOf(b.type as WebRefType);
    });

    return (
        <Container column spacingBottom="large" columnView={columnView}>
            <Title h2 bottomMargin="6" font="regular">
                {translate('productPage.webRefs.title')}
            </Title>
            <Content column columnView={columnView}>
                {sortedWebRefs?.map((webRef, index) => (
                    <WebRef productTitle={productTitle} webRef={webRef} key={`${webRef.type}-${index}`} />
                ))}
            </Content>
        </Container>
    );
};

const Container = styled(Flex)<{ columnView?: boolean }>(({ columnView, theme }) => ({
    marginBottom: '48px',
    ...(!columnView && {
        [mq('frame')]: {
            paddingTop: theme.space[8],
            borderTop: theme.general.border,
            display: 'grid',
            gridTemplateColumns: '50% auto',
            marginBottom: theme.space[12],
        },
    }),
}));

const Title = styled(Text)({
    [mq(0, 'frame')]: {
        display: 'none',
    },
});

const Content = styled(Flex)<{ columnView?: boolean }>(({ columnView }) => ({
    ...(!columnView && {
        [mq('frame')]: {
            paddingLeft: '24px',
            paddingRight: '24px',
        },
    }),
}));
